import DialogCloseWarningComponent from './DialogCloseWarningComponent';
export default DialogCloseWarningComponent;
